import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Haley Halcyon
 * id DFE96305-5114-4F53-AB08-08F99F37C2FE
 * name door-closed
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/door-closed.svg
 * tags
 * - Home Automation 
 */
export const DoorClosedIcon = createSvgIcon(<><path d="M16,11H18V13H16V11M12,3H19C20.11,3 21,3.89 21,5V19H22V21H2V19H10V5C10,3.89 10.89,3 12,3M12,5V19H19V5H12Z" /></>, 'DoorClosedIcon');
export default DoorClosedIcon